import React from "react";
import PageHeader from "../component/layout/pageheader";
import LoaderComponent from "../component/loader/LoaderComponent";
import { toastMaker, validateEmail } from "../utils/utility";
import matrimonyInstance from "../utils/axios";
import { CONTACT_US } from "../API_LIST";
import { Link } from "react-router-dom";

const mailConfirmationPage = () => {
	return (
		<React.Fragment>
			<section className="fore-zero padding-tb">
				<div className="container">
					<div className="section-wrapper">
						<section className="whybat-section padding-tb bg-flower-img">
							<div className="container">
								<div className="section-header">
									<h2
										data-description="title"
										className="color-red-bat-home mt-20 responsive-title text-center mb-20"
									>
										BAT Account Created
									</h2>
									<h5 className="mb-20  text-center">
										Thank you for your kind donation of $150 to the Brahmin
										Association of Texas. You will receive an email confirmation
										for the donation. After the donation has been processed, you
										can avail general member benefits and also be able to login
										to the matrimony section to create free profiles for
										yourself or for your children.
									</h5>
								</div>
								<div className="account-bottom1  text-center">
									<button className="button login-btn create-btn text-white text-center">
										<Link to="/">Go Back Home</Link>
									</button>
								</div>
							</div>
						</section>
					</div>
				</div>
			</section>
		</React.Fragment>
	);
};

export default mailConfirmationPage;
